import { NavLink } from 'react-router-dom'

import clsx from 'clsx'

import {
  ArrowLeftIcon,
  Flex,
  Heading,
  IconButton,
  Sidebar,
  useIsMobileScreenSize,
} from '@buffer-mono/popcorn'

import { MobileSidebar } from '~publish/components/MainSidebar/components/MobileSidebar'
import { usePageTitle } from '~publish/hooks/usePageTitle'

import { SettingsNavigationContent } from './SettingsNavigationContent'

import style from './SettingsSidebar.module.css'

import type { JSX } from 'react'

const SettingsSidebar = ({
  className,
}: {
  className?: string
}): JSX.Element => {
  usePageTitle('Settings')

  const isMobile = useIsMobileScreenSize()

  // Render mobile sidebar on small screens
  if (isMobile) {
    return <MobileSidebar />
  }

  return (
    <Sidebar
      collapsible={isMobile ? 'icon' : 'none'}
      mobileFallback={true}
      className={clsx(style.mainSidebar, className)}
    >
      <Sidebar.Header className={style.sidebarHeader}>
        <Flex align="center" gap="xs">
          <IconButton
            label="Back"
            as={NavLink}
            to="/"
            variant="tertiary"
            size="small"
          >
            <ArrowLeftIcon />
          </IconButton>
          <Heading as="h3" size="small">
            Settings
          </Heading>
        </Flex>
      </Sidebar.Header>
      <Sidebar.Content className={style.sidebar}>
        <SettingsNavigationContent />
      </Sidebar.Content>
    </Sidebar>
  )
}

export default SettingsSidebar
